import React from "react";
import { GlobalBox } from "components/Box/GlobalBox";
import { useDispatch, useSelector } from "react-redux";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { TableInputs } from "components/CardTable/TableInputs";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportInventoryPercentagesFilters, getReportInventoryPercentagesAction } from "redux/actions/Reports/reportInventoryPercentages/reportInventoryPercentagesActions";
import { useSearch } from "hooks/useSearch";

export const ReportInventoryPercentagesView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { date, station } = useSelector(state => state.reportInventoryPercentages);

  const handleSubmit = (isPdf) => {
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (!date) { setSnackbar("Falta seleccionar mes y año.", 'warning'); return; }
    const [year, month] = date.split("-");
    dispatch(getReportInventoryPercentagesAction({ month, year, station, isPdf }));
  };

  return (
    <GlobalBox title="Reporte Porcentajes de Inventario" icon={<AssessmentIcon />}>
      <TableInputs
        reducer="reportInventoryPercentages"
        date
        monthType
        stations
        dispatchAction={setReportInventoryPercentagesFilters}
        submitAction={() => handleSubmit(true)}
        submitSecond={() => handleSubmit(false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingInventoryPercentages}
      />
      {isLoadingComp?.loadingInventoryPercentages && (
        <LoadingComponent height="100%" />
      )}
    </GlobalBox>
  );
};
